import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const RatingsContext = createContext();
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function RatingsProvider({ children }) {
  const [ratings, setRatings] = useState({});

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/reviews-summary`);
      setRatings(res.data || {});
    } catch {
      setRatings({});
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <RatingsContext.Provider value={{ ratings, reloadRatings: load }}>
      {children}
    </RatingsContext.Provider>
  );
}

export const useRatings = () => useContext(RatingsContext);
